import { all, fork } from "redux-saga/effects";
import LayoutSaga from "./layouts/saga";
import AuthSaga from "./auth/saga";
import GovernorateSaga from "./governorate/saga";
import CitySaga from "./city/saga";
import SchoolSaga from "./school/saga";
import CourseSage from "./course/saga";
import GradeSage from "./grade/saga";
import SubjectSaga from "./subject/saga";
import ChapterSaga from "./chapter/saga";
import LessonSaga from "./lesson/saga";
import QuestionSaga from "./question/saga";
import CourseDurationSaga from "./course-duration/saga";
import SkillSaga from "./skill/saga";
import FlashCardSaga from "./flash-card/saga";
import CalendarEventSaga from "./calendar/saga";
import AppSettingsSaga from "./app-settings/saga";
import SupplicationSaga from "./supplication/saga";
import BannerSaga from "./banner/saga";
import AccountSaga from "./account/saga";
import TeacherAdminSaga from "./user/teacher-admin/saga";
import OlympicSaga from "./olympic/saga";
import PromoCodeSaga from "./promo-code/saga";
import PlanSaga from "./plan/saga";
import StudentSaga from "./user/student/saga";
import UserSaga from "./user/user/saga";
import ParentSaga from "./user/parent/saga";
import TeacherSaga from "./user/teacher/saga";
import AnalyticsSaga from "./analytics/saga";
import NotificationSaga from "./notification/saga";
import SubjectNoteSaga from "./subject-note/saga";
import LectureSaga from "./lecture/saga";
import ComplaintsSaga from "./complaints/saga";
import TransactionSaga from "./transaction/saga";
import PurchaseSaga from "./purchase/saga";
import ReportSaga from "./report/saga";
import AppConfigsSaga from "./app-config/saga";
import HomeworkSolutionSaga from "./homework-solution/saga";
import SubscriptionSaga from "./subscription/saga";
import TemplateSaga from "./template/saga";

export default function* rootSaga() {
  yield all([
    fork(LayoutSaga),
    fork(AuthSaga),
    fork(GovernorateSaga),
    fork(CitySaga),
    fork(SchoolSaga),
    fork(CourseSage),
    fork(GradeSage),
    fork(SubjectSaga),
    fork(ChapterSaga),
    fork(LessonSaga),
    fork(QuestionSaga),
    fork(CourseDurationSaga),
    fork(SkillSaga),
    fork(FlashCardSaga),
    fork(CalendarEventSaga),
    fork(AppSettingsSaga),
    fork(SupplicationSaga),
    fork(BannerSaga),
    fork(AccountSaga),
    fork(TeacherAdminSaga),
    fork(OlympicSaga),
    fork(PromoCodeSaga),
    fork(PlanSaga),
    fork(StudentSaga),
    fork(UserSaga),
    fork(ParentSaga),
    fork(TeacherSaga),
    fork(AnalyticsSaga),
    fork(NotificationSaga),
    fork(SubjectNoteSaga),
    fork(LectureSaga),
    fork(ComplaintsSaga),
    fork(TransactionSaga),
    fork(PurchaseSaga),
    fork(ReportSaga),
    fork(AppConfigsSaga),
    fork(HomeworkSolutionSaga),
    fork(SubscriptionSaga),
    fork(TemplateSaga),
  ]);
}
